/**
 * Where the money is paid in.
 *
 * Its own screen rather than a card halfway down Settings. These are the details a tenant is
 * shown when they go to pay, so they get looked at and edited far more often than the timezone or
 * the invoice prefix — and anything reached often enough belongs in the sidebar, not at the end
 * of a scroll.
 */

import { useSession } from "@/lib/session";
import { BankAccounts } from "@/components/bank-accounts";
import { CardPayments } from "@/components/card-payments";
import { PageHeader } from "@/components/ui";

export function BankAccountsPage() {
  const { org, can } = useSession();
  const readOnly = !can("org.settings");

  return (
    <div className="max-w-3xl">
      <PageHeader
        title="Bank accounts"
        subtitle={readOnly ? "Only an administrator can change these." : undefined}
        description={
          "Three steps: the accounts your clients pay into, whether to offer them a card as well, " +
          "and where we settle what we collect on your behalf."
        }
      />

      {/* Numbered because the second only matters once the first is done — and because the two
          are read to a payer and to us respectively, which is a distinction worth making on the
          screen rather than in a field label nobody reads. */}
      <div className="space-y-5">
        <BankAccounts readOnly={readOnly} orgCurrency={String(org?.currency ?? "NGN")} purpose="collection" step={1} />
        <CardPayments readOnly={readOnly} step={2} />
        <BankAccounts readOnly={readOnly} orgCurrency={String(org?.currency ?? "NGN")} purpose="payout" step={3} />
      </div>
    </div>
  );
}
